import styled from "styled-components";
import { breakpoints } from "../../../constants/media";

const Container = styled.div`
  width: 100%;
  max-width: 1290px;
  margin: 160px 0px 0px 0px;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: row;
  background-color: var(--white);

  // Pasos Container
  .pasosContainer {
    width: 33.3%;
    max-width: 346px;
  }

  // Paso
  div div {
    width: 100%;
    padding: 80px 0px 30px 0px;
    background-color: var(--white);
    box-shadow: 0px 5px 30px rgba(9, 30, 66, 0.15);
    border-radius: 12px;
    position: relative;
  }

  // Paso Image
  div div img {
    display: block;
    position: absolute;
    top: -30px;
    left: 0;
    right: 0;
    margin: auto;
  }

  div:nth-child(2) img {
    left: -40px;
  }

  div:nth-child(3) img {
    left: -10px;
  }

  // Paso Title
  div div h3 {
    text-align: center;
    margin: 0px 0px 0px 0px;
    color: var(--black);
    font-family: Raleway;
    font-style: normal;
    font-weight: bold;
    font-size: 2em;
  }

  // Paso Text
  div div p {
    text-align: center;
    max-width: 200px;
    padding: 20px 0px 0px 0px;
    margin: 0 auto;
    color: var(--black);
    font-family: Raleway;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 28px;
  }

  // 1710px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1710}) {
    // Paso Title
    div div h3 {
      font-size: 2em;
    }

    // Paso Text
    div div p {
      font-size: 0.96em;
    }
  }

  // 1600px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1600}) {
    max-width: 1100px;

    // Paso
    .pasosContainer {
      max-width: 326px;
    }
  }

  // 1440px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1440}) {
    // Paso Title
    div div h3 {
      font-size: 1.9em;
    }

    // Paso Text
    div div p {
      font-size: 0.938em;
    }
  }

  // 1366px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1366}) {
    max-width: 1000px;
    margin: 130px 0px 0px 0px;

    // Paso
    .pasosContainer {
      max-width: 300px;
    }

    // Image
    div:nth-child(2) img {
      left: -30px;
    }
  }

  // 1200px Desktop ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.desktop1200}) {
    max-width: 850px;
    margin: 110px 0px 0px 0px;

    // Paso
    .pasosContainer {
      max-width: 260px;
    }

    // Paso Text
    div div p {
      max-width: 200px;
    }
  }

  // 1024px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet1024}) {
    max-width: 700px;

    // Paso
    .pasosContainer {
      max-width: 210px;
    }

    // Paso Text
    div div p {
      max-width: 180px;
      line-height: 28px;
    }
  }

  // 850px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet850}) {
    max-width: 600px;

    // Paso
    .pasosContainer {
      max-width: 180px;
      justify-content: center;
    }

    // Iamge
    div:nth-child(2) img {
      left: -10px;
    }

    // Paso Text
    div div p {
      max-width: 140px;
    }
  }

  // 768px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet768}) {
    max-width: 540px;

    // Paso
    .pasosContainer {
      max-width: 160px;
      justify-content: center;
    }
  }

  // 670px Tablet ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.tablet670}) {
    max-width: 480px;
    margin: 0px 0px 0px 0px;

    // Paso
    .pasosContainer {
      width: 100%;
      max-width: none;
      justify-content: center;
      margin: 80px 0px 0px 0px;
    }

    // Paso Text
    div div p {
      max-width: none;
      width: 100%;
    }
  }

  // 651px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile651}) {
    max-width: 400px;
  }

  // 450px Mobile ------------------------------------------------------------------------------------
  @media (max-width: ${breakpoints.mobile450}) {
    max-width: 75%;

    // Paso Text
    div div p {
      max-width: none;
      width: 80%;
    }
  }
`;

export default Container;
